import Card from 'assets/components/card/Card';
import ThemeCardRow from 'assets/components/card/themes/Theme.Card.Row';
import DataMap from 'assets/components/dataMap/DataMap';
import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import Icon from 'assets/components/icon/Icon';
import TextInput from 'assets/components/inputs/text/TextInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import useApi from 'assets/hooks/api/useApi';
import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import { defaultDateTimeFormat, localizeDate } from 'assets/utils/data/Date';
import dayjs from 'dayjs';
import { set } from 'lodash';
import ContractStatusCode from 'models/enums/ContractStatusCode';
import Contract from 'models/sales/contract/Model.Contract';
import useClaimCreator from 'module/claims/hooks/useClaimCreator';
import { useClaimProvider } from '../Claim.Hooks';
import ClaimCreateButtons from '../other/Claim.CreateButtons';

export default function ClaimAdd() {
  const { lang, translate } = getLocales();
  const { pageRouter } = useClaimProvider();
  const claimCreatorHook = useClaimCreator();

  const contractWithLegacyApi = useApi({
    action: Contract.listWithLegacy,
    wait: true,
    keepResponse: true,
  });

  return (
    <ModalForm<Api.Core.Contract.ListWithLegacy.IRequest>
      subcomponents={ThemeModalFormDefault}
      dependencyArray={[contractWithLegacyApi.payload?.data]}
      title={lang.claim}
      default={contractWithLegacyApi.body}
      onCancel={pageRouter.updateParams}
      onSubmit={(data) => contractWithLegacyApi.execute(data)}
      submitButtonText={lang.search}
      validation={(data, errors) => {
        if (data.clientName && !(data.contractNumber || data.vin)) {
          const message = 'Please provide Contract Number or VIN!';
          set(errors, 'contractNumber', message);
          set(errors, 'vin', message);
        }
      }}
      render={({ form }) => (
        <>
          <FormWrapper>
            <Card
              class={ThemeCardRow}
              style={{
                card: { flexDirection: 'column', padding: 0 },
                cardSubtitle: { fontSize: Theme.FontNestedSize.M },
              }}
              title={lang.submitANewClaim}
            />
            &nbsp;
            <TextInput
              name="contractNumber"
              label={lang.contractNumber}
              value={form.data?.contractNumber}
              error={form.errors.contractNumber}
              onChange={form.update}
              icon={<Icon class="if-quill-pen" />}
            />
            <TextInput
              name="vin"
              label={lang.vin}
              value={form.data?.vin}
              error={form.errors.vin}
              onChange={form.update}
              icon={<Icon class="if-quill-pen" />}
            />
            <TextInput
              name="clientName"
              label={lang.lastName}
              value={form.data?.clientName}
              error={form.errors.clientName}
              onChange={form.update}
              icon={<Icon class="if-quill-pen" />}
            />
          </FormWrapper>
          <table className={ThemeTableSimple}>
            <thead>
              <tr>
                <th children={lang.contractNumber} />
                <th children={lang.status} />
                <th children={lang.clientName} />
                <th children={lang.vin} />
                <th children={lang.expiryDate} />
                <th children={lang.actions} style={{ textAlign: 'center' }} />
              </tr>
            </thead>
            <tbody>
              <DataMap
                data={contractWithLegacyApi.payload?.data}
                render={({ data: contract }) => {
                  const isExpired = dayjs().isAfter(dayjs(contract.expiryDate));
                  return (
                    <tr key={contract.id ?? contract.appNumber}>
                      <td children={contract.appNumber} />
                      <td children={contract.statusCode ? translate(contract.statusCode) : lang.noStatusDefined} />
                      <td children={contract.client?.name} />
                      <td children={contract.vehicle?.vin} />
                      <td
                        style={{
                          color:
                            contract.statusCode === ContractStatusCode.PAID_EXPIRED || isExpired
                              ? Theme.Color.error
                              : undefined,
                        }}
                        children={localizeDate(contract?.expiryDate, defaultDateTimeFormat)}
                      />
                      <td style={{ textAlign: 'center' }}>
                        <ClaimCreateButtons contract={new Contract(contract)} claimCreatorHook={claimCreatorHook} />
                      </td>
                    </tr>
                  );
                }}
              />
            </tbody>
          </table>
        </>
      )}
    />
  );
}
